import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import Select from "react-select";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@radix-ui/react-popover";
import CalendarSvg from "../../assets/svg/Calendar.svg";
import CalenderNew from "../../assets/svg/calendarWhite.svg";
import CalenderBlackSvg from "../../assets/svg/calendarBlack.svg";
import CrossSvg from "../../assets/svg/crossNew.svg";
import DownArrow from "../../assets/svg/DownArrow.svg";
import DownArrowWhite from "../../assets/svg/downArrowWhite.svg";
import SearchSvg from "../../assets/svg/search.svg";
import { DateRange } from "react-day-picker";
import dateFormater from "@/helperFuntions/dateFormater";
import { Calendar } from "@/components/ui/calendar";
import InputText from "@/components/common/InputText";
import { Task } from "@/api/mutation/useTaskCreateMutation";
import { FIELDS } from "@/api/types/enums";
import { useSearchParams } from "react-router-dom";
import {
  ProjectDefaultViewEnumValue,
  TaskStatusEnumValue,
} from "@backend/src/schemas/enums";
import useProjectQuery from "@/api/query/useProjectQuery";
import useDebounce from "@/hooks/useDebounce";
import { useTranslation } from "react-i18next";
type Options = { label: string; value: string };

type Filter = {
  tasks: Task[] | undefined;
  fieldToShow: FIELDS[];
  filteredData: (data: Task[] | undefined) => void;
  view?: string;
  appleed?:(data:boolean)=>void
  small?:boolean
};
export type TaskFilterRef = {
  callFilter: () => void;
};
const TaskFilter = (props: Filter) => {
  const { tasks, fieldToShow } = props;
  const [popOverCLose, setPopOverCLose] = useState(false);
  const [filter, setFilter] = useSearchParams();
  const projects = useProjectQuery();
  const {t} =useTranslation();
  const flags: Options[] = [
    { label: t("select_flag"), value: "" },
    { label: t("SIGNIFICANT_DELAY"), value: "Red" },
    { label: t("ON_TIME"), value: "Green" },
    { label: t("MODERATE_DELAY"), value: "Orange" },
  ];

  const taskOption: Options[] = [
    { label: t("Both"), value: "" },
    { label: t("parent_task"), value: "1" },
    { label: t("sub_task"), value: "2" },
  ];
  const statusOption: Options[] =enumToOptions(TaskStatusEnumValue)
  function enumToOptions(enumObj: any): Options[] {
    return Object.keys(enumObj)?.map((key) => ({
      label: t(enumObj[key as keyof typeof enumObj]),
      value: enumObj[key as keyof typeof enumObj],
    }));
  }
  const assignedTask = (): Options[] | undefined => {
    const projectManagerData: Options[] | undefined = [
      { label: t("select_assigned_user"), value: "" },
    ];
    tasks?.forEach((item) => {
      item.assignedUsers?.forEach((user) => {
        const val = user.user.email;
        const username =
          user.user.firstName && user.user.lastName
            ? user.user.firstName + " " + user.user.lastName
            : val;
        if (!projectManagerData.some((i) => i.value === user.user.email)) {
          projectManagerData.push({ label: username, value: val });
        }
      });
    });
    return projectManagerData;
  };
  const assignedProject = (): Options[] | undefined => {
    const projectData: Options[] | undefined = [
      { label: t("select_project"), value: "" },
    ];
    tasks?.forEach((item) => {
      const project = projects.data?.data.data.find(
        (project) => project.projectId === item.projectId
      );
      const projectName = project?.projectName || "Project Not Found";
      const projectId = project?.projectId || "ID Not Found";
      const projectIds = new Set(projectData.map((project) => project.value));
      if (!projectIds.has(projectId)) {
        projectData.push({ label: projectName, value: projectId });
      }
    });
    return projectData;
  };
  useEffect(() => {
    ApplyFilter();
    if (tasks?.length == 0) {
      props.filteredData([]);
    }
  }, [tasks]);

  const [searchString, setSearchString] = useDebounce<string | undefined>(
    undefined,
    400
  );

  useEffect(() => {
    let tempData: Task[] = [];
    if (searchString !== undefined) {
      if (props.view == ProjectDefaultViewEnumValue.LIST || props.view == ProjectDefaultViewEnumValue.GANTT) {
        tempData = findParentTasksWithTaskName(tasks ?? [], searchString);
        
      } else {
        tasks?.forEach((element) => {
          const searchStringLower = searchString?.toLowerCase();
          const searchStringUpper = searchString?.toUpperCase();
          const taskNameLower = element.taskName?.toLowerCase();
          const taskDescriptionLower = element.taskDescription?.toLowerCase();
          const taskNameUpper = element.taskName?.toUpperCase();
          const taskDescriptionUpper = element.taskDescription?.toUpperCase();
          if (
            (searchStringLower !== undefined &&
              taskNameLower.includes(searchStringLower)) ||
            taskDescriptionLower?.includes(searchStringLower) ||
            taskNameUpper.includes(searchStringUpper) ||
            taskDescriptionUpper?.includes(searchStringUpper)
          ) {
            tempData.push(element);
          }
        });
      }
      props.filteredData(tempData);
    }
  }, [searchString,tasks]);

  const checkTaskName = (task: Task, name: string): boolean => {
    if (task.taskName.toLowerCase().includes(name.toLowerCase())) {
      return true;
    }
    if (task.subtasks && task.subtasks.length > 0) {
      return task.subtasks.some((subtask) => checkTaskName(subtask, name));
    }
    return false;
  };

  function findParentTasksWithTaskName(tasks: Task[], name: string): Task[] {
    const searchName = name.toLowerCase();
    return tasks.filter((task) => checkTaskName(task, searchName));
  }
  const checkTaskFlag = (task: Task, flag: string): boolean => {
    if (task.flag && task.flag.includes(flag)) {
      return true;
    }
    if (task.subtasks && task.subtasks.length > 0) {
      return task.subtasks.some((subtask) => checkTaskFlag(subtask, flag));
    }
    return false;
  };

  function findParentTasksWithFlag(tasks: Task[], name: string): Task[] {
    const searchName = name;
    return tasks.filter((task) => checkTaskFlag(task, searchName));
  }
  const reactSelectStyle = {
    control: (
      provided: Record<string, unknown>,
      state: { isFocused: boolean }
    ) => ({
      ...provided,
      border: "1px solid #E7E7E7",
      paddingTop: "0rem",
      paddingBottom: "0rem",
      outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
      boxShadow: state.isFocused ? "0px 0px 0px #299d91" : "none",
      "&:hover": {
        outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
        boxShadow: "0px 0px 0px #299d91",
      },
    }),
    option: (
      provided: Record<string, unknown>,
      state: { isSelected: boolean }
    ) => ({
      ...provided,
      color: state.isSelected ? "white" : "black",
      background: state.isSelected ? "#299d91" : "white",
      "&:hover": {
        color: "white",
        background: "#299d9199",
      },
    }),
  };

  function isDateSevenDays(inputDate: Date): boolean {
    const sevenDaysAgo: Date = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() + 7);
    return new Date(inputDate) <= sevenDaysAgo;
  }

  function isOverDueDays(inputDate: Date): boolean {
    const currentDate: Date = new Date();
    return new Date(inputDate) <= currentDate;
  }

  function isDueTodayDays(inputDate: Date): boolean {
    const currentDate: Date = new Date();
    return dateFormater(new Date(inputDate)) === dateFormater(currentDate);
  }

  const removeDuplicatesById = (arr: Task[]) => {
    const uniqueIds = new Set();
    return arr.filter(
      ({ taskId }) => !uniqueIds.has(taskId) && uniqueIds.add(taskId)
    );
  };
  const [filterApplyed, setFilterApplied] = useState(false);
  const ApplyFilter = () => {
    let filteredData = tasks;
    if (filter && Boolean(filter.get("flag"))) {
      filteredData = findParentTasksWithFlag(filteredData ?? [], filter.get("flag") ?? "");
    }

    if (
      filter.size &&
      Boolean(filter.get("from")) &&
      Boolean(filter.get("to"))
    ) {
      filteredData = filteredData?.filter((d) => {
        return (
          new Date(d.startDate ?? "") >=
            new Date(filter?.get("from") ?? new Date()) &&
          new Date(d.startDate ?? "") <=
            new Date(filter?.get("to") ?? new Date())
        );
      });
    }

    if (filter && filter.get("assigned")) {
  const assignedEmail = filter.get("assigned")!;
  const result: Task[] = [];

  // Avoid duplicates
  const pushUnique = (task: Task) => {
    if (!result.some((t) => t.taskId === task.taskId)) {
      result.push(task);
    }
  };

  // 1. Deep search for assigned user
  const containsUserDeep = (task: Task): boolean => {
    // Check current task
    if (task.assignedUsers?.some((u) => u.user.email === assignedEmail)) {
      return true;
    }

    // Recursively check subtasks
    if (Array.isArray(task.subtasks)) {
      return task.subtasks.some(containsUserDeep);
    }

    return false;
  };

  // 2. Climb parent chain and push all parents
  const pushParents = (task: Task) => {
    if (!task.parentTaskId) return;

    const parent = filteredData?.find((t) => t.taskId === task.parentTaskId);
    if (parent) {
      pushUnique(parent);
      pushParents(parent); // recursion upward
    }
  };

  // 3. Iterate top-level tasks (tasks with subtasks inside)
  filteredData?.forEach((task) => {
    if (containsUserDeep(task)) {
      pushUnique(task); // push the task that matched
      pushParents(task); // push all parents
    }
  });

  filteredData = result;
}



    if (filter && filter.get("completed")) {
      filteredData = filteredData?.filter(
        (data) =>
          Number(data.completionPecentage) != 100 ||
          data.status !== TaskStatusEnumValue.COMPLETED
      );
    }

    if (filter && filter.get("dueSevenDays")) {
      filteredData = filteredData?.filter((data) =>
        isDateSevenDays(data.endDate)
      );
    }

    if (filter && filter.get("overdueDays")) {
      filteredData = filteredData?.filter((data) =>
        isOverDueDays(data.endDate)
      );
    }

    if (filter && filter.get("todayDueDays")) {
      filteredData = filteredData?.filter((data) =>
        isDueTodayDays(data.endDate)
      );
    }
    if (filter && filter.get("projectId")) {
      filteredData = filteredData?.filter(
        (data) => data.projectId === filter.get("projectId")
      );
    }

    if (filter && filter.get("tasks")) {
      let val;
      if (filter.get("tasks") === "1") {
        val = filteredData?.filter((data) => !data.parentTaskId);
      }
      if (filter.get("tasks") === "2") {
        val = filteredData?.filter((data) => !!data.parentTaskId);
      }
      if (val && val.length > 0) {
        filteredData = val;
      }
    }

    let applyFilter = 0;
    filter.forEach((e) => {
      const task  = filter.get("task");
      if (
        ![
          ProjectDefaultViewEnumValue.GANTT,
          "NEW"+ProjectDefaultViewEnumValue.GANTT,
          ProjectDefaultViewEnumValue.KANBAN,
          ProjectDefaultViewEnumValue.CALENDAR,
          ProjectDefaultViewEnumValue.LIST,
          task
        ].includes(e as keyof typeof ProjectDefaultViewEnumValue)
      ) {
        if (Boolean(e) || e !== "false") {
          applyFilter++;
        }
      }
    });

    if (applyFilter !== 0 && filteredData) {
      setFilterApplied(true);
      filteredData = removeDuplicatesById(filteredData);
      props.filteredData(filteredData);
    } else {
      props.filteredData(tasks);
      setFilterApplied(false);
    }

    setPopOverCLose(false);
  };
  const resetFilter = () => {
    setFilterApplied(false);
    setFilter({ view: filter.get("view") ?? "" });
    props.filteredData(tasks);
  };
  const setParamFilter = (key: string, value: string) => {
    filter.set(key, value);
    setFilter(filter);
    if ((value == "undefined" && !value) || value == "false") {
      filter.delete(key);
      setFilter(filter);
    }
  };

  const selectedDate = () => {
    const formDate = filter.get("from");
    const toDate = filter.get("to");
    const data: DateRange = { from: new Date(), to: new Date() };
    if (Boolean(formDate) && formDate !== "undefined" && formDate !== null) {
      data.from = new Date(formDate);
    }
    if (Boolean(toDate) && toDate !== "undefined" && toDate !== null) {
      data.to = new Date(toDate);
    }
    return data;
  };

  return (
    <div>
      <div className="flex w-full justify-between items-center gap-2">
        <div className="flex justify-between w-full gap-2 text-gray-500">
          <div className="flex justify-between items-center gap-6 px-3 w-full relative">
            <div>
              <Popover open={popOverCLose}>
                <PopoverTrigger className="w-full ">
                  <Button
                    variant={"outline"}
                    className="w-fit h-10 rounded-xl px-1"
                    style={{
                      backgroundColor: filterApplyed ? "#299d91" : "",
                      color: filterApplyed ? "#ffffff" : "",
                    }}
                    onClick={() => setPopOverCLose(!popOverCLose)}
                  >
                    <div className="flex justify-between gap-5 items-center">
                      <div className="flex items-center justify-between gap-1">
                        <div className="w-5">
                          <img
                            src={filterApplyed ? CalenderNew : CalenderBlackSvg}
                          />
                        </div>
                        {!props.small && t("Filters")}{" "}
                      </div>
                      <div className="w-5 ">
                        <img src={filterApplyed ? DownArrowWhite : DownArrow} />
                      </div>
                    </div>
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="z-20 absolute bg-white shadow-lg mr-5 max-h-screen overflow-y-auto -translate-x-[20%]">
                  <div className="p-3 w-80 flex flex-col gap-3 !z-20">
                    <div>
                      <div className="text-lg font-semibold">{t("Filters")}</div>
                      <hr />
                    </div>
                    <div className="w-full flex flex-col gap-3">
                      {fieldToShow.includes(FIELDS.DUESEVENDAYS) && (
                        <div className="flex justify-between items-center">
                          <div>{t("Due_in_7_day")}</div>
                          <div>
                            <label className="relative inline-flex items-center cursor-pointer">
                              <input
                                type="checkbox"
                                name="sevenDays"
                                checked={
                                  filter.get("dueSevenDays") == "true"
                                    ? true
                                    : false
                                }
                                onChange={(e) =>
                                  setParamFilter(
                                    "dueSevenDays",
                                    String(e.target.checked)
                                  )
                                }
                                className="sr-only peer"
                              />
                              <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary-600 dark:peer-focus:ring-primary-400 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-primary-400"></div>
                            </label>
                          </div>
                        </div>
                      )}
                      {fieldToShow.includes(FIELDS.OVERDUEDAYS) && (
                        <div className="flex justify-between items-center">
                          <div>{t("over_due")}</div>
                          <div>
                            <label className="relative inline-flex items-center cursor-pointer">
                              <input
                                type="checkbox"
                                name="dueDays"
                                checked={
                                  filter.get("overdueDays") == "true"
                                    ? true
                                    : false
                                }
                                onChange={(e) =>
                                  setParamFilter(
                                    "overdueDays",
                                    String(e.target.checked)
                                  )
                                }
                                className="sr-only peer"
                              />
                              <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-2  peer-focus:ring-primary-600 dark:peer-focus:ring-primary-400 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-primary-400"></div>
                            </label>
                          </div>
                        </div>
                      )}
                      {fieldToShow.includes(FIELDS.TODAYDUEDAYS) && (
                        <div className="flex justify-between items-center">
                          <div>{t("due_by_today")}</div>
                          <div>
                            <label className="relative inline-flex items-center cursor-pointer">
                              <input
                                type="checkbox"
                                name="todayDays"
                                checked={
                                  filter.get("todayDueDays") == "true"
                                    ? true
                                    : false
                                }
                                onChange={(e) =>
                                  setParamFilter(
                                    "todayDueDays",
                                    String(e.target.checked)
                                  )
                                }
                                className="sr-only peer"
                              />
                              <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary-600 dark:peer-focus:ring-primary-400 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-primary-400"></div>
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="flex justify-between items-center">
                      <div>{t("hide_completed_task")}</div>
                      <div>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            name="sevenDays"
                            checked={
                              filter.get("completed") == "true" ? true : false
                            }
                            onChange={(e) =>
                              setParamFilter(
                                "completed",
                                String(e.target.checked)
                              )
                            }
                            className="sr-only peer"
                          />
                          <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary-600 dark:peer-focus:ring-primary-400 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-primary-400"></div>
                        </label>
                      </div>
                    </div>
                    {fieldToShow.includes(FIELDS.DATE) && (
                      <div className="w-full">
                        <Popover>
                          <PopoverTrigger className="w-full">
                            <Button
                              variant={"outline"}
                              className="w-full h-10 rounded p-0 px-2"
                            >
                              <div className="flex justify-between text-base items-center w-full text-gray-950 font-normal">
                                {Boolean(filter.get("from")) &&
                                Boolean(filter.get("to"))
                                  ? `${dateFormater(
                                    new Date(filter.get("from") ?? new Date())
                                  )}-
                          ${dateFormater(
                        new Date(filter.get("to") ?? new Date())
                      )}`
                                  : t("select_start_date")}
                                <img src={CalendarSvg} width={20} />
                              </div>
                            </Button>
                          </PopoverTrigger>
                          <PopoverContent className="z-50 bg-white ">
                            <div>
                              <Calendar
                                mode="range"
                                selected={selectedDate()}
                                onSelect={(e) => {
                                  e?.from
                                    ? setParamFilter("from", String(e?.from))
                                    : "",
                                  e?.to
                                    ? setParamFilter("to", String(e?.to))
                                    : "";
                                }}
                                className="rounded-md border"
                              />
                            </div>
                          </PopoverContent>
                        </Popover>
                      </div>
                    )}
                    {fieldToShow.includes(FIELDS.ASSIGNED) && (
                      <div className="w-full">
                        <Select
                          className="p-0 z-40"
                          value={
                            filter.get("assigned")
                              ? {
                                label: filter.get("assigned"),
                                value: filter.get("assigned"),
                              }
                              : {
                                label: t("select_assigned_user"),
                                value: "",
                              }
                          }
                          options={assignedTask()}
                          onChange={(e) => {
                            if (e && e.value == "") {
                              setParamFilter("assigned", "");
                            } else {
                              setParamFilter("assigned", String(e?.value));
                            }
                          }}
                          placeholder={t("select_assigned_user")}
                          styles={reactSelectStyle}
                        />
                      </div>
                    )}
                    {fieldToShow.includes(FIELDS.FLAGS) && (
                      <div className="w-full">
                        <Select
                          className="p-0 "
                          value={
                            filter.get("flag")
                              ? flags.find(f=>f.value == filter.get("flag"))
                              : { label: t("select_flag"), value: "" }
                          }
                          options={flags}
                          onChange={(e) => {
                            if (e && e.value == "") {
                              setParamFilter("flag", "");
                            } else {
                              setParamFilter("flag", String(e?.value));
                            }
                          }}
                          placeholder={t("select_flag")}
                          styles={reactSelectStyle}
                        />
                      </div>
                    )}
                    {fieldToShow.includes(FIELDS.TASK) && (
                      <div className="w-full">
                        <Select
                          className="p-0 "
                          value={
                            filter.get("tasks")
                              ? taskOption.find(
                                (d) => d.value == filter.get("tasks")
                              )
                              : { label: t("Both"), value: "" }
                          }
                          options={taskOption}
                          onChange={(e) => {
                            if (e && e.value == "") {
                              setParamFilter("tasks", "");
                            } else {
                              setParamFilter("tasks", String(e?.value));
                            }
                          }}
                          placeholder={t("select_task")}
                          styles={reactSelectStyle}
                        />
                      </div>
                    )}
                    {fieldToShow.includes(FIELDS.STATUS) && (
                      <div className="w-full">
                        <Select
                          className="p-0 "
                          value={
                            filter.get("status")
                              ? statusOption.find(
                                (d) => d.value == filter.get("status")
                              )
                              : { label: t("select_status"), value: "" }
                          }
                          options={[{ label: t("select_status"), value: "" },...statusOption]}
                          onChange={(e) => {
                            if (e && e.value == "") {
                              setParamFilter("status", "");
                            } else {
                              setParamFilter("status", String(e?.value));
                            }
                          }}
                          placeholder={t("select_task")}
                          styles={reactSelectStyle}
                        />
                      </div>
                    )}
                    {fieldToShow.includes(FIELDS.PROJECTS) && (
                      <div className="w-full">
                        <Select
                          className="p-0 "
                          value={
                            filter.get("projectId")
                              ? {
                                label: projects.data?.data.data.find(
                                  (project) =>
                                    project.projectId ===
                                      filter.get("projectId")
                                )?.projectName,
                                value: filter.get("projectId"),
                              }
                              : { label: t("select_project"), value: "" }
                          }
                          options={assignedProject()}
                          onChange={(e) => {
                            if (e && e.value == "") {
                              setParamFilter("projectId", "");
                            } else {
                              setParamFilter("projectId", String(e?.value));
                            }
                          }}
                          placeholder={t("Select Project")}
                          styles={reactSelectStyle}
                        />
                      </div>
                    )}
                    {fieldToShow.length != 0 && (
                      <div className="w-full flex gap-2">
                        <Button
                          className="w-full mt-4"
                          variant={"destructive"}
                          onClick={() => setPopOverCLose(false)}
                        >
                          {t("close")}
                        </Button>
                        <Button
                          className="w-full mt-4"
                          variant={"primary_outline"}
                          onClick={ApplyFilter}
                        >
                          {t("apply")}
                          
                        </Button>
                      </div>
                    )}
                  </div>
                </PopoverContent>
              </Popover>
            </div>
            {filterApplyed && (
              <div>
                <Button
                  size={"sm"}
                  className="w-5 h-5 rounded-[50%] px-2 bg-[#EA4335] hover:bg-[#EA4335] absolute left-28  bottom-7"
                  variant={"outline"}
                  onClick={resetFilter}
                >
                  <div className="flex items-center justify-between gap-2 ">
                    <div className="w-2">
                      <img src={CrossSvg} className="m-auto" />
                    </div>
                  </div>
                </Button>
              </div>
            )}
            <div className="w-full flex gap-2 relative items-center">
              <InputText
                className={`pl-11 pr-3 mt-0 h-10 truncate ${props.small ? "!w-36" : "!w-56"} border-primary-500/5 placeholder:text-sm bg-primary-500/5 rounded-md focus:outline-primary-700`}
                onChange={(e) => setSearchString(e.target.value)}
                placeholder={t("search_tasks_by_name")}
              />
              <img
                src={SearchSvg}
                className="absolute h-5 left-3 top-3"
                width={"20px"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskFilter;
